"use client"
import { Avatar, Text } from "@/elements"
import type { NovaSession } from "@/types"
import Link from "next/link"
import { type ButtonHTMLAttributes, forwardRef } from "react"
import { getProfileLinkDetails } from "./FloatingNav"
import { useSession } from "@/hooks/useSession"

interface ProfileLinkButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  serverSession?: NovaSession | null
}

export const ProfileLinkButton = forwardRef<HTMLButtonElement, ProfileLinkButtonProps>((props, ref) => {
  const { serverSession } = props
  const profileDetails = getProfileLinkDetails(serverSession)
  const { update } = useSession()
  const handleProfileSwitch = async () => {
    if (profileDetails?.switchAccount) {
      const newAccount = profileDetails.switchAccount
        ? serverSession?.account === "creative"
          ? "client"
          : "creative"
        : serverSession?.account
      await update({
        account: newAccount,
      })
    }
  }
  return (
    <Link onClick={handleProfileSwitch} href={profileDetails?.href || "/sign-up"}>
      <button
        {...props}
        className="group flex h-12 flex-col items-center overflow-hidden rounded-full bg-marketing-primary-dark pl-2 pr-4 text-marketing-background-1-light shadow-[19px_6px_16px_0px_rgba(100,10,217,0.14),0px_4px_20px_0px_rgba(229,150,215,0.35)] dark:bg-marketing-primary-light dark:text-marketing-background-1-dark"
        ref={ref}>
        <div className="flex h-12 shrink-0 flex-row items-center gap-x-2">
          <Avatar
            src={serverSession?.user.profile.avatarUrl144w}
            initials={serverSession?.user.avatarInitials}
            size="sm"
          />{" "}
          <Text className="marketing-transition-button-text flex h-12 shrink-0 items-center text-marketing-background-1-dark group-hover:-translate-y-full group-hover:opacity-0 dark:text-marketing-background-1-light">
            Go to profile
          </Text>
        </div>
        <div className="flex h-12 shrink-0 flex-row items-center gap-x-2">
          <Avatar
            src={serverSession?.user.profile.avatarUrl144w}
            initials={serverSession?.user.avatarInitials}
            size="sm"
          />{" "}
          <Text className="marketing-transition-button-text flex h-12 shrink-0 items-center text-marketing-background-1-dark opacity-0 group-hover:-translate-y-full group-hover:opacity-100 dark:text-marketing-background-1-light">
            Go to profile
          </Text>
        </div>
      </button>
    </Link>
  )
})

ProfileLinkButton.displayName = "ProfileLinkButton"
